import { cn } from "@/lib/utils";

export function ConsoleCard({
  title,
  meta,
  children,
  showDots = true,
  className,
}: {
  title?: string;
  meta?: string;
  children: React.ReactNode;
  showDots?: boolean;
  className?: string;
}) {
  return (
    <section className={cn("overflow-hidden rounded-lg border border-line bg-console-bg", className)}>
      <header className="flex items-center justify-between border-b border-line bg-console-panel px-3.5 py-2">
        <div className="flex items-center gap-2.5">
          {showDots && (
            <div aria-hidden className="flex gap-1.5">
              <span className="size-2 rounded-full bg-console-danger" />
              <span className="size-2 rounded-full bg-console-warning" />
              <span className="size-2 rounded-full bg-console-success" />
            </div>
          )}
          {title && <span className="font-mono text-xs text-console-muted">{title}</span>}
        </div>
        {meta && (
          <span className="font-mono text-[11px] uppercase tracking-wider text-console-muted">{meta}</span>
        )}
      </header>
      <div className="p-4 font-mono text-[13px] leading-relaxed text-console-text">{children}</div>
    </section>
  );
}

export function CodeBlock({
  code,
  className,
}: {
  code: string;
  className?: string;
}) {
  return (
    <pre className={cn("overflow-x-auto rounded-md border border-line bg-console-panel p-3 font-mono text-[13px] leading-relaxed text-console-text", className)}>
      <code>{code}</code>
    </pre>
  );
}